import React from "react";

import "./index.scss";

export default function DupontButton(props) {
  const { id = "dupont-button", type = "primary", color = "primary", disabled, onClick, customClass = "", children } = props;
  const getBtnClass = type => {
    let btnClass = `dupont-btn__${type}`;
    if (color) {
      btnClass = `${btnClass}--${color}`;
    }
    return btnClass;
  };

  return (
    <button id={id} className={`dupont-btn ${getBtnClass(type)} ${customClass}`} disabled={disabled} onClick={onClick}>
      {children}
    </button>
  );
}
